import { Grid, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import BasicTooltip from "src/components/BasicTooltip";
import Iconify from "src/components/Iconify";
import Label from "src/components/Label";

import ThemeContext from "../../../context";
import Context from "../../context";
import useGetTransferPositions from "../../hooks/useGetTransferPositions";

// ----------------------------------------------------------------------

type Props = {
	positionId: string;
};

export const PositionItemName = ({ positionId }: Props) => {
	const { theme } = useContext(ThemeContext);
	const { state } = useContext(Context);
	const { positions } = useGetTransferPositions();

	const position = positions.find((position) => position.positionId === positionId);
	const positionSel = state.selectedPositions.find((position) => position.id === positionId);

	const { name, portfolio, owners } = position || { name: "", portfolio: "", owners: [] };

	const isTotal = !positionSel?.shares && positionSel?.shares !== null;

	return (
		<Stack mr={2}>
			<Grid
				container
				rowSpacing={0.5}
				columnSpacing={{ xs: 1, sm: 2 }}
				sx={{ mb: 0.5 }}
				alignItems={"center"}
			>
				<Grid item>
					<Stack flexDirection={"row"} alignItems={"center"} gap={2}>
						<Typography
							variant='subtitle1'
							maxWidth={220}
							noWrap
							fontSize={16}
							color={theme?.colors.primaryText}
						>
							{name}
						</Typography>
						<BasicTooltip title={portfolio}>
							<Iconify icon={"ion:wallet"} width={13} color={theme?.colors.secondaryText} />
						</BasicTooltip>
					</Stack>
				</Grid>
				<Grid item>
					<Label color={isTotal ? "primary" : "turquoise"}>
						{isTotal ? "Traspaso total" : "Traspaso parcial"}
					</Label>
				</Grid>
			</Grid>
			<Typography variant='body1' sx={{ mt: 1 }} fontSize={11} color={theme?.colors.secondaryText}>
				{owners[0]}
			</Typography>
		</Stack>
	);
};

export default PositionItemName;
